import { API } from '../../utils/API';
import Axios from 'axios';

export const getPopular = () => {
  return async (dispatch) => {
    try {
      dispatch({
        type: 'GET_POPULAR',
      });
      const response = await Axios.get(API.url + '/services/popular');

      const { data } = response.data;

      dispatch({
        type: 'GET_POPULAR_SUCCESS',
        payload: data,
      });
    } catch (err) {
      dispatch({
        type: 'GET_POPULAR_FAILURE',
        payload: err,
      });
    }
  };
};
